import React, {
  useEffect,
  useState,
} from 'react';
import isNil from 'lodash/isNil';
import List from 'views/EMR/Settings/Appointments/List';
import Dialog, {
  AppointmentTypeDialogParams,
} from 'views/EMR/Settings/Appointments/Dialog';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';

export default function AppointmentTypeSettings() {
  const [
    createAppointmentTypeDialogParams,
    setCreateAppointmentTypeDialogParams,
  ] = useState<AppointmentTypeDialogParams | null>(null);

  useEffect(() => {
    const unsubscribe = settingsEventChannel.on('onCreateAppointmentType', (params) => {
      setCreateAppointmentTypeDialogParams(params);
    });

    return () => { unsubscribe(); };
  }, []);

  return (
    <>
      <List />
      {!isNil(createAppointmentTypeDialogParams) && (
        <Dialog
          {...createAppointmentTypeDialogParams}
          onClose={() => { setCreateAppointmentTypeDialogParams(null); }}
        />
      )}
    </>
  );
}
